/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  DatePicker,
} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
/*
import {
  getDiasFestivosDelAñoPag,
  getDiasFestivosDelAño,
  postDiaFestivoDelAño,
  deleteDiaFestivoDelAño,
  patchDiaFestivoDelAño,
  getDiaFestivoDelAño,
  autorizarDiaFestivoDelAño,
} from 'api/configuraciones/clock/DiasFestivos/FestivosDelAño'; */
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import moment from 'moment';

const IncidenciaPre_EliminarReloj = ({ permission, parent_data }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  // const dataNormalizer = (dataArray) => {
  //   if (!Array.isArray(dataArray)) return [];
  //   return dataArray.map((row) => {
  //     const nameToSplit = row?.numero_y_nombre_completo_empelado;
  //     const [number, _] = nameToSplit ? nameToSplit.split(' - ') : '';

  //     return {
  //       ...row,
  //       numero_de_empleado: number,
  //       horario_jornada_entrada: row.jornada_detalle_horario?.de_las,
  //       horario_jornada_salida: row.jornada_detalle_horario?.a_las,
  //       justificacion: row?.justificacion_reloj_checador?.justificacion,
  //     };
  //   });
  // };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      fecha: record.fecha
        ? moment(record.fecha)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 100,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Día',
      dataIndex: 'dia_de_la_semana_nombre',
      key: 'dia_de_la_semana_nombre',
      width: 100,
    },
    {
      titleText: 'No. de Empleado',
      dataIndex: 'numero_de_empleado',
      key: 'numero_de_empleado',
      width: 150,
    },
    {
      titleText: 'Nombre del Empleado',
      dataIndex: 'numero_y_nombre_completo_empelado',
      key: 'numero_y_nombre_completo_empelado',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 100,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 190,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Hora de Entrada',
      dataIndex: 'hora_entrada',
      key: 'hora_entrada',
      width: 150,
    },
    {
      titleText: 'Hora de Salida',
      dataIndex: 'hora_salida',
      key: 'hora_salida',
      width: 150,
    },
    {
      titleText: 'Evaluación de Entrada',
      dataIndex: 'tipo_de_evaluacion_entrada',
      key: 'tipo_de_evaluacion_entrada',
      width: 190,
    },
    {
      titleText: 'Evaluación de Salida',
      dataIndex: 'tipo_de_evaluacion_salida',
      key: 'tipo_de_evaluacion_salida',
      width: 180,
    },
    {
      titleText: 'Evaluación Otros',
      dataIndex: 'tipo_de_evaluacion_otro',
      key: 'tipo_de_evaluacion_otro',
      width: 160,
    },
    /*
    {
      titleText: 'Minutos de Incidencia',
      dataIndex: 'minutos_incidencia',
      key: 'minutos_incidencia',
      width: 180,
    },
    {
      titleText: 'Justificación',
      dataIndex: 'justificacion',
      key: 'justificacion',
      width: 150,
    },
    */
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={parent_data}
          allowExportPDF={false}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          permission={permission}
        />
      </Spin>
    </Row>
  );
};

export default IncidenciaPre_EliminarReloj;
